import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';
import { HttpGuardService } from 'src/app/guards/http-guard.service';

@Injectable({
  providedIn: 'root'
})
export class FloorPlanService {

  constructor(
    private httpGuard: HttpGuardService,

  ) { }

  getEntitydetails(payload) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.availableEntitiesFloorPlan, payload,false);
  }

  updateEntityLocation(payload) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.updateEntityLocation, payload,false);
  }

  deleteEntityLocation(payload) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.deleteEntityLocation, payload,false);
  }
}
